// Анимация заголовков секций — появление при скролле, исчезновение при уходе из зоны видимости
document.addEventListener('DOMContentLoaded', function() {
    var sectionTitles = document.querySelectorAll('.section-title');

    sectionTitles.forEach(function(title) {
        if (title.dataset.animated === 'true') {
            return;
        }

        var text = title.textContent.trim();
        title.innerHTML = '';

        var container = document.createElement('span');
        container.className = 'section-title__chars';

        var charIndex = 0;
        var words = text.split(' ');

        words.forEach(function(word, wordIndex) {
            // Обёртка для слова (inline-block чтобы не разрывалось)
            var wordSpan = document.createElement('span');
            wordSpan.className = 'section-title__word';
            wordSpan.style.display = 'inline-block';
            wordSpan.style.whiteSpace = 'nowrap';

            // Разбиваем слово на символы
            word.split('').forEach(function(char) {
                var charSpan = document.createElement('span');
                charSpan.className = 'section-title__char';
                charSpan.textContent = char;
                charSpan.style.display = 'inline-block';
                charSpan.dataset.index = charIndex;
                wordSpan.appendChild(charSpan);
                charIndex++;
            });

            container.appendChild(wordSpan);

            // Пробел между словами (кроме последнего)
            if (wordIndex < words.length - 1) {
                var spaceSpan = document.createElement('span');
                spaceSpan.className = 'section-title__char section-title__space';
                spaceSpan.textContent = '\u00A0';
                spaceSpan.style.display = 'inline-block';
                spaceSpan.dataset.index = charIndex;
                container.appendChild(spaceSpan);
                charIndex++;
            }
        });

        title.appendChild(container);
        title.dataset.animated = 'true';
        title.classList.add('section-title--animated');

        var charElements = Array.from(title.querySelectorAll('.section-title__char'));
        var totalChars = charElements.length;

        // Появление — буквы по очереди слева направо
        function setVisible() {
            title.classList.remove('section-title--exit');
            title.classList.add('section-title--visible');

            charElements.forEach(function(charEl, index) {
                charEl.style.transitionDelay = (index * 0.01) + 's';
                charEl.classList.add('section-title__char--visible');
                charEl.classList.remove('section-title__char--hidden');
            });
        }

        // Исчезновение — буквы в обратном порядке
        function setExit() {
            title.classList.remove('section-title--visible');
            title.classList.add('section-title--exit');

            charElements.forEach(function(charEl, index) {
                var reverseIndex = totalChars - 1 - index;
                charEl.style.transitionDelay = (reverseIndex * 0.01) + 's';
                charEl.classList.remove('section-title__char--visible');
                charEl.classList.add('section-title__char--hidden');
            });
        }

        // IntersectionObserver — анимация при скролле
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    setVisible();
                } else {
                    setExit();
                }
            });
        }, { threshold: 0.2 });

        observer.observe(title);
    });
});

